<template>
  <div :id="'post-favorite-tooltip-' + post.id" class="favorite" :class="{ active }" @click="toggle">
    <fa-icon :icon="['fal', 'bookmark']"></fa-icon>
    <fa-icon :icon="['fa', 'bookmark']"></fa-icon>
    <b-tooltip :target="'post-favorite-tooltip-' + post.id" :title="tooltip" placement="left" :disabled="$isMobile"></b-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'Item-Default',
    data () {
      return {
        active: false
      };
    },
    props: {
      post: Object
    },
    computed: {
      tooltip () {
        return !this.active ? 'Auf Merkzettel speichern' : 'Von Merkzettel entfernen';
      }
    },
    mounted () {
      this.active = this.$store.getters.favorites.indexOf(this.post.id) > -1;
    },
    methods: {
      async toggle () {
        await this.$http.post('favorites/toggle', {
          deviceId: this.$store.getters.deviceId,
          postId: this.post.id
        });

        this.active = !this.active;
        this.$store.commit('toggleFavorite', this.post.id);
        this.$emit((this.active ? '' : 'un') + 'favorited', this.post.id);


        try {
          this.$ua.trackEvent('post', 'favorite');
        } catch (e) { /* Adblocker */ }

        try {
          this.$mixpanel.track('Post Favorite', {
            postId: this.post.id,
            source: this.post.source.name,
            url: this.post.url,
            title: this.post.title
          });
        } catch (e) { /* Adblocker */ }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .favorite {
    cursor: pointer;

    svg {
      vertical-align: middle;
    }

    svg:nth-child(2) {
      color: #549F0B;
    }
  }

  .favorite:not(.active) {
    svg:nth-child(1) {
      display: inline;
    }

    svg:nth-child(2) {
      display: none;
      color: #549F0B;
    }

    @media (hover: hover) {
      &:hover {
        svg:nth-child(1) {
          display: none;
        }

        svg:nth-child(2) {
          display: inline;
        }
      }
    }
  }

  .favorite.active {
    svg:nth-child(1) {
      display: none;
    }

    svg:nth-child(2) {
      display: inline;
    }

    @media (hover: hover) {
      &:hover {
        svg:nth-child(1) {
          display: inline;
        }

        svg:nth-child(2) {
          display: none;
        }
      }
    }
  }
</style>
